import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-registry-steps-confirm-wrapper',
    templateUrl: './registry-steps-confirm-wrapper.component.html',
    styleUrls: ['./registry-steps-confirm-wrapper.component.css'],
    standalone: false
})
export class RegistryStepsConfirmWrapperComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
